<template>
  <v-content>
    <v-card class="d-flex align-center justify-center grey lighten-3" flat tile height="100vh">
      <v-card flat tile :width="350" :height="640">
        <h1 class="display-1 ml-7 mt-5 font-weight-light">Signup</h1>
        <v-card-text class="px-6 mt-n1">
          <v-form ref="form" v-model="valid" lazy-validation>
            <v-text-field
              label="Employee ID"
              v-model="employeeId"
              v-on:keyup.enter="handleSignin"
              :rules="[v => !!v || 'Employee ID is required']"
            ></v-text-field>

            <v-text-field
              label="Email"
              v-model="email"
              type="email"
              v-on:keyup.enter="handleSignin"
              :rules="[v => !!v || 'Email is required']"
            ></v-text-field>

            <v-text-field
              label="First Name"
              v-model="firstName"
              v-on:keyup.enter="handleSignin"
              :rules="[v => !!v || 'First Name is required']"
            ></v-text-field>

            <v-text-field
              label="Last Name"
              v-model="lastName"
              v-on:keyup.enter="handleSignin"
              :rules="[v => !!v || 'Last Name is required']"
            ></v-text-field>

            <v-text-field
              label="Username"
              v-model="userName"
              v-on:keyup.enter="handleSignin"
              :rules="[v => !!v || 'Username is required']"
            ></v-text-field>

            <v-text-field
              label="Password"
              type="password"
              v-model="password"
              v-on:keyup.enter="handleSignin"
              :rules="[v => !!v || 'Password is required']"
            ></v-text-field>

            <v-text-field
              label="Confirm Password"
              type="password"
              v-model="password2"
              v-on:keyup.enter="handleSignin"
              :rules="[v => !!v || 'Password is required']"
            ></v-text-field>
          </v-form>
        </v-card-text>
        <v-card-actions class="px-6">
          <v-btn
            large
            block
            depressed
            :disabled="loading"
            :loading="loading"
            color="primary"
            class="mt-n5"
            @click="handleSignin"
          >
            <template v-slot:loader>
              <v-progress-circular :width="2" :size="20" indeterminate></v-progress-circular>
              <span class="ml-2">Signing-up...</span>
            </template>
            Sign-up
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-card>
  </v-content>
</template>

<script>
export default {
  name: "Login",
  data: () => ({
    loading: false,
    valid: true,

    employeeId: "",
    email: "",
    firstName: "",
    lastName: "",
    userName: "",
    password: "",
    password2: ""
  }),
  methods: {
    async handleSignin() {
        if (this.$refs.form.validate()) {
            this.loading = true;
            this.$Progress.start();
            if(this.password !== this.password2){
                this.$toast.open({
                    type: 'error',
                    message: 'Password do not match!',
                    position: 'top-right'
                })
                this.loading = false;
                this.$Progress.fail();
            }else{
                let formData = {
                    employeeId: this.employeeId,
                    email: this.email,
                    firstName: this.firstName,
                    lastName: this.lastName,
                    userName: this.userName,
                    password: this.password
                }
                try {
                    let response = await this.$http.post("/auth/signup", JSON.stringify(formData));
                    localStorage.setItem('user', JSON.stringify(response.data))
                    localStorage.setItem("token", response.data.token);
                    this.$http.defaults.headers.common["x-auth-token"] = response.data.token;
                    this.$router.push("/");

                    this.loading = false;
                    this.$Progress.finish();
                } catch (error) {
                    if(error.status === 500){
                        error.data.errors.map(err => {
                            this.$toast.open({
                                type: 'error',
                                message: err.msg,
                                duration: 5000,
                                position: 'top-right'
                            })
                        })
                    }
                    
                    this.loading = false;
                    this.$Progress.fail();
                }
            }
        
        }
    }
  }
};
</script>